import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f2c5b992&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f2c5b992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c5b992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c5b992')) {
      api.createRecord('f2c5b992', component.options)
    } else {
      api.reload('f2c5b992', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f2c5b992&scoped=true&", function () {
      api.rerender('f2c5b992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/DocBox.vue"
export default component.exports